import { Divider, Flex, VStack, Box } from '@cad-arc';
import { EventSearchOptions, EventSearchStatics } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { EventSearchFormDispositionsSection } from './event-search-form-dispositions-section';
import { SearchFormLocationSection } from '../search-windows/search-form-location-section';
import { EventSearchFormPrimarySection } from './event-search-form-primary-section';
import { EventSearchFormInvolvedUnitsSection } from './event-search-form-involved-units-section';
import { EventSearchFormSelfInitiatedSection } from './event-search-form-self-initiated-section';
import { EventSearchFormType } from './types';
import { EventSearchFormSecondarySection } from './event-search-form-secondary-section';
import { EventSearchFormPersonInformationSection } from './event-search-form-person-information-section';
import { EventSearchFormInvolvedItemInformationSection } from './event-search-form-property-information-section';
import { EventSearchFormVehicleInformationSection } from './event-search-form-vehicle-information-section';
import { EventSearchFormAttachmentsSection } from './event-search-form-attachments-section';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export function EventSearchFormBody({
    form,
    options,
    statics,
    isFirstResponder,
}: {
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
    statics: EventSearchStatics;
    isFirstResponder?: boolean;
}) {
    const { involvedPropertyEnabled, mediaAttachmentsEnabled } = useEnabledFeatures();

    return (
        <VStack gap="20px" align="left">
            <EventSearchFormPrimarySection form={form} options={options} statics={statics} />
            <Divider />
            <EventSearchFormInvolvedUnitsSection form={form} options={options} />
            <Divider />
            <SearchFormLocationSection title="Event Location" options={options} />
            <Divider />
            <Flex gap="1rem">
                <EventSearchFormPersonInformationSection
                    form={form}
                    options={options}
                    isFirstResponder={isFirstResponder}
                />
                <Box borderLeft="1px solid var(--arc-colors-border-default)" />
                <EventSearchFormVehicleInformationSection
                    form={form}
                    options={options}
                    isFirstResponder={isFirstResponder}
                />
            </Flex>
            <Divider />
            <EventSearchFormSecondarySection form={form} options={options} statics={statics} />
            <Divider />
            <Flex gap="1rem">
                <EventSearchFormDispositionsSection form={form} options={options} />
                <Box borderLeft="1px solid var(--arc-colors-border-default)" />
                <EventSearchFormSelfInitiatedSection form={form} options={options} />
            </Flex>
            {involvedPropertyEnabled && (
                <>
                    <Divider />
                    <EventSearchFormInvolvedItemInformationSection
                        form={form}
                        options={options}
                        isFirstResponder={isFirstResponder}
                    />
                </>
            )}
            {mediaAttachmentsEnabled && (
                <>
                    <Divider />
                    <EventSearchFormAttachmentsSection form={form} options={options} />
                </>
            )}
        </VStack>
    );
}
